import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoFixtureIdentity, DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';
import {
  buildMidJourneyPslfFetchMatchers,
  buildMidJourneyPslfMatchers,
} from 'tio-employee/demo/products/pslf-fixtures';

/**
 * Builds the demo matchers + fixtures for the PSLF product. Each scenario maps
 * to a set of request matchers the demo handler serves, so the main-app PSLF
 * dashboard renders demo data through its normal store calls (no route forks).
 * Borrower/employer names derive from the shared fixture identity.
 *
 * Only the mid-journey ("full-journey") scenario ships fixtures today; the
 * other scenario ids fall through to the real network until authored.
 */
export function buildPslfDemo(
  config: Extract<DemoProductConfig, { kind: 'pslf' }>,
  _scenario: DemoScenario,
  identity: DemoFixtureIdentity
): DemoScenarioResolved {
  if (config.scenarioId === 'full-journey') {
    return {
      matchers: buildMidJourneyPslfMatchers(identity),
      fetchMatchers: buildMidJourneyPslfFetchMatchers(identity),
      seed: [],
    };
  }
  return { matchers: [], seed: [] };
}
